import { useCallback } from 'react'

import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { useModalContext } from '@/contexts/ModalContext'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useGameSlug } from '@/features/storefronts/game-provider'

import { BonusView } from './BonusOverlay'

import styles from './bonusOverlayHeader.module.scss'

interface BonusOverlayHeaderProps {
  onClick: (view: BonusView) => void
  selectedView: BonusView
}

export const BonusOverlayHeader = ({ onClick, selectedView }: BonusOverlayHeaderProps) => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const { openModal } = useModalContext()
  const showInfoModal = useCallback(() => {
    openModal({ type: 'BONUS_INFO' })
  }, [openModal])

  return (
    <div className={styles.bonusTrackHeaderContainer}>
      <div className={cx(styles.bonusTrackHeader, styles[gameSlug])}>
        <div className={cx(styles.info, styles[gameSlug])} onClick={() => showInfoModal()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="3" height="10" viewBox="0 0 3 10" fill="none">
            <rect x="0" y="4" width="3" height="5" fill="black" />
            <rect x="0" y="0" width="3" height="3" fill="black" />
          </svg>
        </div>
        <StoreTypography tag="h2" textSize="lg" style="plain" overrideFont="supercellHeadline" className={styles.title}>
          {t('bonus_track')}
        </StoreTypography>

        <div className={styles.buttonsContainer}>
          <button
            className={cx(styles.button, { [styles.selected]: selectedView === 'bonuses' })}
            onClick={() => onClick('bonuses')}
            data-cy="button-bonuses"
          >
            {t('bonus_track_bonuses')}
          </button>
          <button
            className={cx(styles.button, { [styles.selected]: selectedView === 'missions' })}
            onClick={() => onClick('missions')}
            data-cy="button-points"
          >
            {t('missions')}
          </button>
        </div>
      </div>
    </div>
  )
}
